import { render, staticRenderFns } from "./LeadersMessage.vue?vue&type=template&id=20fac5ae&scoped=true&"
import script from "./LeadersMessage.vue?vue&type=script&lang=js&"
export * from "./LeadersMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeadersMessage.vue?vue&type=style&index=0&id=20fac5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fac5ae",
  null
  
)

export default component.exports